/*
<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
*/

(function () {
    'use strict';

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run, {once: true});
    } else {
        run();
    }

    function run() {
        if (location.pathname === '/cart' || location.pathname === '/cart/') {
            runForCartPage();
        }
    }

    /* =========================================================================
     * Cart page specific code
     * =========================================================================
     */

    function runForCartPage() {
        tryToToggleMessageForm();

        const form = document.querySelector('.cart-total > form');
        form.addEventListener('change', tryToToggleMessageFormEvent);

        const mutationObserver = new MutationObserver(tryToToggleMessageFormMutation);
        mutationObserver.observe(form, {childList: true, attributes: true, subtree: true});

        document.addEventListener('click', e => {
          // if (e.target.closest('.gs__checkbox-container') || e.target.closest('.cart-item-remove')) {
          //     setTimeout(() => {
          //         location.reload();
          //     }, 2500);
          // }
        });

        const shipToMultipleAddressesButtons = document.querySelectorAll('[data-ship-to-multiple-addresses-button]');

        for (const button of shipToMultipleAddressesButtons) {
            shipToMultipleAddressesButtonInit(button);
        }
    }

    function tryToToggleMessageFormEvent(event) {
        if (event.target.matches('input[value="39255216914494"]')) {
            tryToToggleMessageForm();
        }
    }

    function tryToToggleMessageFormMutation(mutationList) {
        for (const mutation of mutationList) {
            if (mutation.target.matches('input[value="39255216914494"]')) {
                tryToToggleMessageForm();
            }

            for (const addedNode of mutation.addedNodes) {
                if (addedNode.nodeType === 1  && addedNode.querySelector('input[value="39255216914494"]')) {
                    tryToToggleMessageForm();
                }
            }
        }
    }

    function tryToToggleMessageForm() {
        const giftCardCheckbox = document.querySelector('input[value="39255216914494"]');
        const messageForm = document.querySelector('.gs__toggle-feature-item');

        if (!giftCardCheckbox || !messageForm) {
            return;
        }

        if (giftCardCheckbox.checked) {
            messageForm.removeAttribute('hidden');
        } else {
            messageForm.setAttribute('hidden', '');
        }
    }

    function shipToMultipleAddressesButtonInit(root) {
        root.addEventListener('click', shipToMultipleAddressesButtonClicked);
    }

    function shipToMultipleAddressesButtonClicked() {
        const label = document.querySelector('#gs__toggle-shipping');

        label.dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
    }

    /* =========================================================================
     * Other page specific code
     * =========================================================================
     */


})();
